/**
 *
 * @returns {module:url.URLSearchParams}
 */
function getQueryStringParams(){
    let uri = window.location.search.substring(1);
    return new URLSearchParams(uri);
}



export { getQueryStringParams }
